__turbopack_context__.v({
  "notificationsDrawer": "_02R6vq_notificationsDrawer",
  "notificationsDrawer__actions": "_02R6vq_notificationsDrawer__actions",
  "notificationsDrawer__card": "_02R6vq_notificationsDrawer__card",
  "notificationsDrawer__cardActions": "_02R6vq_notificationsDrawer__cardActions",
  "notificationsDrawer__cardButton": "_02R6vq_notificationsDrawer__cardButton",
  "notificationsDrawer__closeButton": "_02R6vq_notificationsDrawer__closeButton",
  "notificationsDrawer__empty": "_02R6vq_notificationsDrawer__empty",
  "notificationsDrawer__header": "_02R6vq_notificationsDrawer__header",
  "notificationsDrawer__list": "_02R6vq_notificationsDrawer__list",
  "notificationsDrawer__loadingMore": "_02R6vq_notificationsDrawer__loadingMore",
  "notificationsDrawer__message": "_02R6vq_notificationsDrawer__message",
  "notificationsDrawer__messageCollapsed": "_02R6vq_notificationsDrawer__messageCollapsed",
  "notificationsDrawer__skeletonCard": "_02R6vq_notificationsDrawer__skeletonCard",
  "notificationsDrawer__skeletonList": "_02R6vq_notificationsDrawer__skeletonList",
  "notificationsDrawer__timestamp": "_02R6vq_notificationsDrawer__timestamp",
  "notificationsDrawer__unreadIndicator": "_02R6vq_notificationsDrawer__unreadIndicator",
});
